import {MoreVert} from '@mui/icons-material'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'

import Avatar from '../../../../components/Avatar/Avatar'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import {MenuPosition} from '../../../../hooks/useCoords'
import useMenu from '../../../../hooks/useMenu'
import useModal from '../../../../hooks/useModal'
import {Button} from '../../../../ui/Button/Button'
import PromoteTeamMemberModal from '../../../teamDashboard/components/PromoteTeamMemberModal/PromoteTeamMemberModal'
import RemoveTeamMemberModal from '../../../teamDashboard/components/RemoveTeamMemberModal/RemoveTeamMemberModal'
import {OrgTeamMemberMenu} from './OrgTeamMemberMenu'







export const OrgTeamMembersRow = (props) => {
  const {teamMemberRef} = props
  const teamMember = useFragment(
    graphql`
      fragment OrgTeamMembersRow_teamMember on TeamMember {
        ...OrgTeamMemberMenu_teamMember
        userId
        picture
        preferredName
        isLead
        isOrgAdmin
        isSelf
        email
        ...PromoteTeamMemberModal_teamMember
        ...RemoveTeamMemberModal_teamMember
      }
    `,
    teamMemberRef
  )

  const {isViewerLead, isViewerOrgAdmin} = props
  const {isLead, isOrgAdmin, userId} = teamMember

  const atmosphere = useAtmosphere()
  const {viewerId} = atmosphere
  const isSelf = userId === viewerId

  const showMenuButton = (isViewerOrgAdmin && !isLead) || (isViewerLead && !isSelf && !isOrgAdmin)

  const {togglePortal, originRef, menuPortal, menuProps} = useMenu(MenuPosition.UPPER_RIGHT)
  const {
    closePortal: closePromote,
    togglePortal: togglePromote,
    modalPortal: portalPromote
  } = useModal()
  const {
    closePortal: closeRemove,
    togglePortal: toggleRemove,
    modalPortal: portalRemove
  } = useModal()

  return (
    React.createElement('div', { className: "flex w-full items-center justify-center gap-4 p-4"     ,}
      , React.createElement('div', null
        , React.createElement(Avatar, { className: "h-8 w-8" , picture: teamMember.picture, alt: teamMember.preferredName,} )
      )
      , React.createElement('div', { className: "flex w-full flex-col gap-y-1 py-1"    ,}
        , React.createElement('div', { className: "text-gray-700 inline-flex items-center gap-x-2 text-lg font-bold"     ,}
          , teamMember.preferredName, ' '
          , teamMember.isLead ? (
            React.createElement('span', { className: "rounded-full bg-primary px-2 py-0.5 text-xs text-white"     ,}, "Team Lead"

            )
          ) : null
        )
        , React.createElement('div', null
          , React.createElement(Button, { asChild: true, variant: "link",}
            , React.createElement('a', { href: `mailto:${teamMember.email}`,}, teamMember.email)
          )
        )
      )
      , React.createElement('div', null
        , showMenuButton && (
          React.createElement(Button, {
            disabled: !showMenuButton,
            shape: "circle",
            variant: "ghost",
            onClick: togglePortal,
            ref: originRef,}

            , React.createElement(MoreVert, null )
          )
        )
        , menuPortal(
          React.createElement(OrgTeamMemberMenu, {
            menuProps: menuProps,
            isLead: teamMember.isLead,
            teamMember: teamMember,
            isViewerLead: isViewerLead,
            isViewerOrgAdmin: isViewerOrgAdmin,
            togglePromote: togglePromote,
            toggleRemove: toggleRemove,}
          )
        )
      )

      , portalPromote(React.createElement(PromoteTeamMemberModal, { teamMember: teamMember, closePortal: closePromote,} ))
      , portalRemove(React.createElement(RemoveTeamMemberModal, { teamMember: teamMember, closePortal: closeRemove,} ))
    )
  )
}
